import { apiRequest } from './apiClient';
import {
  EmpresaAprovacaoDetalhe,
  EmpresaAprovacaoPage,
  EmpresaAprovacaoQuery,
} from '../types/empresaApproval';

export function empresaAprovacaoQueryString(query: EmpresaAprovacaoQuery): string {
  const params = new URLSearchParams({
    page: String(query.page),
    pageSize: String(query.pageSize),
  });
  const optional: Array<[string, string | undefined]> = [
    ['statusAnalise', query.statusAnalise],
    ['cnpj', query.cnpj],
    ['razaoSocial', query.razaoSocial],
    ['tipoEmpresa', query.tipoEmpresa],
    ['papel', query.papel],
    ['uf', query.uf],
    ['cadastradaDe', query.cadastradaDe],
    ['cadastradaAte', query.cadastradaAte],
  ];
  optional.forEach(([key, value]) => {
    if (value?.trim()) params.set(key, value.trim());
  });
  return params.toString();
}

export function listarAprovacoesEmpresas(
  accessToken: string,
  query: EmpresaAprovacaoQuery,
): Promise<EmpresaAprovacaoPage> {
  return apiRequest<EmpresaAprovacaoPage>(
    `/empresas/aprovacoes?${empresaAprovacaoQueryString(query)}`,
    accessToken,
  );
}

export function detalharAprovacaoEmpresa(
  accessToken: string,
  empresaId: string,
): Promise<EmpresaAprovacaoDetalhe> {
  return apiRequest<EmpresaAprovacaoDetalhe>(
    `/empresas/${empresaId}/aprovacao`,
    accessToken,
  );
}

export function aprovarEmpresa(
  accessToken: string,
  empresaId: string,
  parecer: string,
): Promise<EmpresaAprovacaoDetalhe> {
  return decidirEmpresa(accessToken, empresaId, 'aprovar', parecer);
}

export function rejeitarEmpresa(
  accessToken: string,
  empresaId: string,
  parecer: string,
): Promise<EmpresaAprovacaoDetalhe> {
  return decidirEmpresa(accessToken, empresaId, 'rejeitar', parecer);
}

function decidirEmpresa(
  accessToken: string,
  empresaId: string,
  action: 'aprovar' | 'rejeitar',
  parecer: string,
): Promise<EmpresaAprovacaoDetalhe> {
  return apiRequest<EmpresaAprovacaoDetalhe>(
    `/empresas/${empresaId}/${action}`,
    accessToken,
    { method: 'POST', body: JSON.stringify({ parecer: parecer.trim() }) },
  );
}
